import { IntakeAddressPersistence } from './intake-address.persistence';

export class IntakeAddressService {
  private persistence = new IntakeAddressPersistence();

  public getIntakeAddress(jobId: number): Promise<string> {
    return this.persistence.getIntakeAddress(jobId);
  }
}
